import { AxiosInstance } from "axios";
import { BoardLookup } from "models/BoardLookup";
import { EditSendToTargetsModel } from "models/EditSendToTargetsModel";
import { SiveActionResult } from "models/SiveActionResult";

export class BoardSendToApi {
  constructor(private axios: AxiosInstance) {}

  async getTargets(boardId: string): Promise<EditSendToTargetsModel> {
    const response = await this.axios.get<EditSendToTargetsModel>(`api/boards/${boardId}/sendToTargets`);
    return response.data;
  }

  async addOutgoing(boardId: string, targetId: number): Promise<SiveActionResult> {
    const response = await this.axios.patch<SiveActionResult>(
      `api/boards/${boardId}/sendToTargets/outgoing/${targetId}`
    );
    return response.data;
  }

  async addIncoming(boardId: string, sourceId: number): Promise<SiveActionResult> {
    const response = await this.axios.patch<SiveActionResult>(
      `api/boards/${boardId}/sendToTargets/incoming/${sourceId}`
    );
    return response.data;
  }

  async remove(boardId: string, id: number): Promise<SiveActionResult> {
    const response = await this.axios.delete<SiveActionResult>(`api/boards/${boardId}/sendToTargets/${id}`);
    return response.data;
  }

  async search(boardId: string, q: string, permission: "CanView" | "CanEdit"): Promise<BoardLookup[]> {
    const response = await this.axios.get<BoardLookup[]>(`api/boards/${boardId}/sendToTargets/search`, {
      params: { q, permission },
    });
    return response.data;
  }
}
